import { render, staticRenderFns } from "./SearchResource.vue?vue&type=template&id=cdd10392"
import script from "./SearchResource.vue?vue&type=script&lang=js"
export * from "./SearchResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports